import { IsString, IsUUID } from 'class-validator';

import { ValueDto } from './value.dto';

export class RawValueDto {
  @IsUUID()
  uuid!: string;

  @IsString()
  sourceId!: string;

  @IsString()
  timestampIn!: string;

  values: ValueDto[];

  constructor(values: ValueDto[]) {
    this.values = values;
  }
}
